'use strict';

/**
 * Lazily required module dependencies
 */

var utils = require('lazy-cache')(require);
// lazy-cache sugar removed by fix-clone-deep plugin
utils('is-plain-object', 'isObject');
utils('shallow-clone', 'clone');
utils('kind-of', 'typeOf');
require('for-own');
// restored by fix-clone-deep plugin

/**
 * Expose `utils`
 */

module.exports = utils;
